// Stati della scheda ricorso (regole dello studio del 21/10, come collettivi.STATI_DEPOSITATI nel
// backend): il deposito è definitivo, da questi stati non si torna a in_lavorazione, da_depositare
// o revocato; revocato vale solo per gli individuali. Un collettivo depositato ha l'elenco dei
// ricorrenti chiuso.
export const STATI_DEPOSITATI = ['depositato', 'estinto', 'estinto_e_ripresentato', 'chiuso'];
export const STATI_PRIMA_DEL_DEPOSITO = ['in_lavorazione', 'da_depositare', 'revocato'];
export const depositato = (ricorso) => STATI_DEPOSITATI.includes(ricorso?.stato);

// Gradi del ricorso (vincolo CHECK di ricorsi.grado e di tipi_ricorso.grado, migrazione 026)
export const GRADI = [['primo_grado', 'Primo grado'], ['appello', 'Appello'], ['ottemperanza', 'Ottemperanza'],
  ['ottemperanza_ottemperanza', 'Ottemperanza di ottemperanza']];

// Tipi proposti nel form ricorso: solo quelli del grado scelto e attivi. assegnato = tipo già sulla
// scheda (Modifica): resta visibile anche se disattivato o di un altro grado.
export function tipiPerGrado(tipi, grado, assegnato = null) {
  return tipi.filter(t => (assegnato != null && String(t.id) === String(assegnato))
    || ((t.grado || 'primo_grado') === (grado || 'primo_grado') && t.attivo !== false));
}
